/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_No_GuidesInputs */

const en_knp_manager_no_guides = /** @type {(inputs: Knp_Manager_No_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No KNP guides yet. Create one to get started.`)
};

const fr_knp_manager_no_guides = /** @type {(inputs: Knp_Manager_No_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun guide KNP pour le moment. Créez-en un pour commencer.`)
};

const de_knp_manager_no_guides = /** @type {(inputs: Knp_Manager_No_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es gibt noch keine KNP-Guides. Erstelle einen, um loszulegen.`)
};

const it_knp_manager_no_guides = /** @type {(inputs: Knp_Manager_No_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna guida KNP ancora disponibile. Creane una per iniziare.`)
};

const ru_knp_manager_no_guides = /** @type {(inputs: Knp_Manager_No_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет путеводителей по КНП. Создайте свой, чтобы начать.`)
};

const es_knp_manager_no_guides = /** @type {(inputs: Knp_Manager_No_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay guías de KNP. Crea una para empezar.`)
};

const zh_cn2_knp_manager_no_guides = /** @type {(inputs: Knp_Manager_No_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目前还没有克鲁格国家公园的导览手册。创建一份导览手册即可开始。`)
};

const ja_knp_manager_no_guides = /** @type {(inputs: Knp_Manager_No_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KNPガイドはまだありません。まずは作成しましょう。`)
};

const hi_knp_manager_no_guides = /** @type {(inputs: Knp_Manager_No_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई KNP गाइड उपलब्ध नहीं है। शुरुआत करने के लिए एक गाइड बनाएं।`)
};

const pt_pt2_knp_manager_no_guides = /** @type {(inputs: Knp_Manager_No_GuidesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não existem guias sobre o Parque Nacional Kruger. Crie um para começar.`)
};

/**
* | output |
* | --- |
* | "No KNP guides yet. Create one to get started." |
*
* @param {Knp_Manager_No_GuidesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_no_guides = /** @type {((inputs?: Knp_Manager_No_GuidesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_No_GuidesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_no_guides(inputs)
	if (locale === "de") return de_knp_manager_no_guides(inputs)
	if (locale === "it") return it_knp_manager_no_guides(inputs)
	if (locale === "ru") return ru_knp_manager_no_guides(inputs)
	if (locale === "es") return es_knp_manager_no_guides(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_no_guides(inputs)
	if (locale === "ja") return ja_knp_manager_no_guides(inputs)
	if (locale === "hi") return hi_knp_manager_no_guides(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_no_guides(inputs)
	return en_knp_manager_no_guides(inputs)
});